import { FontWeight } from '../components/Text/Text.constants';
import palette from '../palette';
import { hexToRgb } from '../utils';
export const THEME_FONTS = {
  fontFamilyPrimary: 'Montserrat, DejaVu Sans, Verdana, sans‑serif',
  fontFamilySecondary: 'mBank, DejaVu Sans, Verdana, sans‑serif',
  fontWeightPrimary: FontWeight.WEIGHT_500,
  fontWeightSecondary: 'normal',
  fontFamilyMonoSpace: 'Roboto Mono, monospace'
};
export const COMMON_THEME_COLORS = {
  light: palette.solidWhite,
  dark: palette.zeusBlackUI
};
export const LIGHT_THEME_MONO_COLORS = {
  mono000: palette.solidWhite,
  mono100: palette.solidWhite,
  mono200: palette.wildSandGray,
  mono500: palette.altoGray,
  mono600: palette.doveGrayUI,
  mono700: palette.doveGrayUIHover,
  mono900: palette.zeusBlackUI
};
export const DARK_THEME_MONO_COLORS = {
  mono000: palette.solidBlack,
  mono100: palette.flatBlackUI,
  mono200: palette.solidBlack,
  mono500: palette.jetGray,
  mono600: palette.webGrayUI,
  mono700: palette.doveGrayUI,
  mono900: palette.solidWhite
};
export const LIGHT_THEME_SEMANTIC_COLORS = {
  negative: palette.thunderbirdRedUI,
  negativeDarken: palette.brightRedUI,
  negativeContrast: palette.thunderbirdRedUI,
  negativeContrastDarken: palette.brightRedUI,
  positive: palette.funGreenUI,
  positiveDarken: palette.funGreenUIHover,
  positiveContrast: palette.funGreenUI,
  positiveContrastDarken: palette.funGreenUIHover,
  attention: palette.confettiYellow,
  attentionContrast: palette.desertOrangeUI
};
export const DARK_THEME_SEMANTIC_COLORS = {
  negative: palette.thunderbirdRedUI,
  negativeDarken: palette.brightRedUI,
  negativeContrast: palette.pigmentRedUI,
  negativeContrastDarken: palette.begoniaUI,
  positive: palette.funGreenUI,
  positiveDarken: palette.funGreenUIHover,
  positiveContrast: palette.slimyGreenUI,
  positiveContrastDarken: palette.emeraldUI,
  attention: palette.confettiYellow,
  attentionContrast: palette.flushOrange
};
export const LIGHT_THEME_SHADOWS = {
  common: `4px 4px 0 0 rgba(${hexToRgb(palette.solidBlack)}, 0.08)`
};
export const DARK_THEME_SHADOWS = {
  common: `4px 4px 0 0 rgba(${hexToRgb(palette.solidWhite)}, 0.08)`
};